export default class CreditRequest {
  constructor(creditRequest) {
    this.credit_request = {
      course_org: creditRequest.courseOrg,
      course_num: creditRequest.courseNum,
      course_run: creditRequest.courseRun,
      enrollment_timestamp: creditRequest.enrollmentTimestamp,
      final_grade: creditRequest.finalGrade,
      course_completion_timestamp: creditRequest.courseCompletionTimestamp,
      user_username: creditRequest.username,
      user_email: creditRequest.userEmail,
      user_full_name: creditRequest.userFullName,
      lms: creditRequest.lms
    };
    this.enrollmentId = creditRequest.enrollmentId;
  }
}
